import { Fragment } from "react";
import { Section } from "design-react-kit";
import Footer from "../../components/Footer";
import SubNavigation from "../../components/Header/SubNavigation";
import DragNdrop from "../../components/DragNdrop";

const UploadFiles = () => {
  return (
    <Fragment>
      <SubNavigation page="uploadFiles" />
      <Section>
        <div className="d-flex justify-content-center w-100 h-100">
          <DragNdrop width="600px" />
        </div>
      </Section>
      <Footer />
    </Fragment>
  );
};

export default UploadFiles;
